import React, { useState } from 'react';
import LoadingSpinner from './LoadingSpinner';
import '../styles/History.css';

const History = ({ passOns, isLoading }) => {
  const [visibleCount, setVisibleCount] = useState(10);

  const filteredPassOns = passOns || [];
  const visiblePassOns = filteredPassOns.slice(0, visibleCount);

  const handleLoadMore = () => {
    setVisibleCount(prev => prev + 10);
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'Unknown time';
    
    // Handle Firestore Timestamp
    if (timestamp.toDate) {
      return timestamp.toDate().toLocaleString();
    }
    
    // Handle regular Date or string
    return new Date(timestamp).toLocaleString();
  };

  if (isLoading) {
    return (
      <div className="history">
        <h2>History</h2>
        <LoadingSpinner message="Loading history..." />
      </div>
    );
  }

  if (filteredPassOns.length === 0) {
    return (
      <div className="history">
        <h2>History</h2>
        <div className="no-history">No messages yet. Start the chain!</div>
      </div>
    );
  }

  return (
    <div className="history">
      <div className="history-header">
        <h2>History ({filteredPassOns.length} items)</h2>
      </div>

      <div className="history-list">
        {visiblePassOns.map((passOn, index) => {
          const previousPassOn = index < visiblePassOns.length - 1 ? visiblePassOns[index + 1] : null;
          return (
            <div key={passOn.id} className="history-item">
              <div className="history-item-header">
                <h3 className="history-item-name">
                  {previousPassOn 
                    ? `${passOn.title || passOn.name || 'Anonymous'} replied to ${previousPassOn.title || previousPassOn.name || 'Anonymous'}:`
                    : `${passOn.title || passOn.name || 'Anonymous'} said:`
                  }
                </h3>
                <span className="history-item-timestamp">
                  {formatTimestamp(passOn.createdAt || passOn.timestamp)}
                </span>
              </div>
              <p className="history-item-text">
                {passOn.description || passOn.text}
              </p>
              {(passOn.gifUrl || passOn.imageUrl) && (
                <div className="history-item-image">
                  <img 
                    src={passOn.gifUrl || passOn.imageUrl} 
                    alt="Pass-on content" 
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {visibleCount < filteredPassOns.length && (
        <div className="load-more-container">
          <button className="load-more-button" onClick={handleLoadMore}>
            Load More ({filteredPassOns.length - visibleCount} remaining)
          </button>
        </div>
      )}
    </div>
  );
};

export default History;